/**
 *
 * DropDown
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import SearchTextField from "basicComponents/TextField/TextField";
import styled from "styled-components";
import injectClickOutside from "react-click-outside";
import { FormattedMessage } from "react-intl";
import Arrow from "images/Arrow";
import Item from "./Item";

export class DropDown extends Component {
  static propTypes = {
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    items: PropTypes.array.isRequired,
    value: PropTypes.string,
    error: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    singleArrow: PropTypes.bool,
    disableMaxWidth: PropTypes.bool,
    enableSearch: PropTypes.bool,
    searchText: PropTypes.any,
    onSearchChange: PropTypes.func,
  };

  static defaultProps = {
    placeholder: "",
    enableSearch: false,
  };

  state = {
    selectedValue: this.props.value,
    open: false,
  };

  componentDidMount() {
    this.checkControlled();
  }

  checkControlled() {
    if (typeof this.props.value === "string" && !this.props.onChange) {
      throw Error("Controlled components needs an onChange handler");
    }
  }

  get isControlled() {
    return typeof this.props.value === "string";
  }

  get selected() {
    if (this.isControlled) {
      return this.props.value;
    }
    return this.state.selectedValue;
  }

  handleClickOutside() {
    this.setState({
      open: false,
    });
  }

  handleOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleItemClicked = async (value, index) => {
    if (!this.isControlled) {
      this.setState({
        selectedValue: value,
      });
    }
    this.setState({
      open: false,
    });
    if (this.props.onChange) {
      this.props.onChange(value, index);
    }
  };

  renderContent() {
    return (
      <OpenWrapper>
        {this.props.enableSearch && (
          <SearchContainer>
            <SearchTextField
              dropDownEnableSearch={this.props.enableSearch}
              value={this.props.searchText}
              onChange={this.handleSearchTextChanged}
            />
          </SearchContainer>
        )}
        <ItemContainer>
          {this.props.items.map((item, index) => (
            <Item
              onClick={this.handleItemClicked}
              id={item}
              key={item}
              value={item}
              index={index}
            />
          ))}
        </ItemContainer>
      </OpenWrapper>
    );
  }

  renderCurrent() {
    let current = null;
    if (this.state.selectedValue && !this.isControlled) {
      current = this.state.selectedValue;
    } else {
      current = this.props.value;
    }
    if (!current) {
      return this.props.placeholder;
    }

    switch (typeof current) {
      case "object":
        return <FormattedMessage {...current} />;
      case "string":
      default:
        return <span>{current}</span>;
    }
  }

  handleSearchTextChanged = e => {
    this.props.onSearchChange(e);
  };

  render() {
    return (
      <Wrapper
        disableMaxWidth={this.props.disableMaxWidth}
        error={this.props.error}
        id="dropdown"
        onClick={this.handleOpen}
      >
        <TextContainer id="textInput">{this.renderCurrent()}</TextContainer>
        <ArrowWrapper>
          {this.props.singleArrow ? (
            <SingleArrowWrapper>
              <Arrow down />
            </SingleArrowWrapper>
          ) : (
            <>
              <Arrow style={{ marginBottom: "-4px" }} up />
              <Arrow style={{ marginTop: "-4px" }} down />
            </>
          )}
        </ArrowWrapper>
        {this.state.open && this.renderContent()}
      </Wrapper>
    );
  }
}

export default injectClickOutside(DropDown);

const SearchContainer = styled.div``;

const OpenWrapper = styled.div`
  z-index: 999;
  box-sizing: border-box;
  border: inherit;
  background-color: white;
  position: absolute;
  width: calc(100% + 22px);
  left: -11px;
  top: -1px;
  height: auto;
  max-height: 260px;
  border-radius: inherit;
  overflow: hidden;
`;

const SingleArrowWrapper = styled.div`
  width: 35%;
  height: 35%;
`;

const ItemContainer = styled.div`
  overflow-y: auto;
  height: inherit;
  max-height: 218px;
`;

const TextContainer = styled.div`
  height: 100%;
  padding-left: ${({ theme }) => theme.padding}rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Wrapper = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  ${({ theme, error }) =>
    `border: 1px solid ${
      error ? theme.palette.error.main : theme.borderColor
    }`};
  position: relative;
  border-radius: 10px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  line-height: 2rem;
  height: 2rem;
  width: 100%;
  ${({ disableMaxWidth }) => !disableMaxWidth && "max-width: 15rem"};
`;

const ArrowWrapper = styled.div`
  margin-right: ${({ theme }) => theme.padding}rem;
  width: 1rem;
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
